/**
 * Oprávnění modulu Security (zrcadlí backend `SecurityPermissions.RolePermissions`).
 * Jeden uzel katalogu s úrovněmi: `read` = prohlížení admin agendy (menu, gate),
 * `edit` = změna grantů rolí.
 */
export const SECURITY_ROLE_PERMISSIONS = 'security.role-permissions';
